export const sidebarStateLocalStorageKey = 'sidebarState';
